import { Spin } from "antd";
import { get } from "lodash";
import { useState } from "react";
import { MdShoppingCart } from "react-icons/md";
import { CURRENCY_SYMBOL, TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import CartModal from "./Modal";

function Cart({ project, generalCost, updateStatus, loading, upsells = [] }) {
  const [open, setOpen] = useState(false);
  const totalAmount = upsells
    .reduce((acc, { cost }) => (acc += cost), get(generalCost, "cost", 0))
    .toFixed(2);
  const onSubmit = () => {
    updateStatus({
      template:
        TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].PRODUCTS,
    });
  };

  const onClose = () => setOpen(false);

  const onOpen = () => setOpen(true);

  return (
    <>
      <div className="mobilityMutual__cart" onClick={onOpen}>
        {loading ? (
          <Spin />
        ) : (
          <>
            <MdShoppingCart size={20} className="mobilityMutual__cart-icon" />
            <span className="mobilityMutual__cart-price">
              {costToFrench(totalAmount)}{" "}
              {CURRENCY_SYMBOL[generalCost?.currency] || CURRENCY_SYMBOL.EUR}
            </span>
          </>
        )}
      </div>
      <CartModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        generalCost={generalCost}
        project={project}
        totalAmount={totalAmount}
        upsells={upsells}
      />
    </>
  );
}

export default Cart;
